<script setup lang="ts">
import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'

export interface ContactFormProps {
  name?: string
  disclaimer: string
}

withDefaults(defineProps<ContactFormProps>(), {
  name: 'Newsletter Subscription',
  disclaimer:
    'By submitting, you give Atlas Creative permission to store and process your personal information so we can provide you with the content you’ve requested.'
})

const emit = defineEmits(['submit'])

const isSending = ref(false)
const state = reactive({
  email: ''
})
const rules = {
  email: { required, email }
}
const v$ = useVuelidate(rules, state)

const { newsletterSubscribe } = useHubSpotAPI()

// Form submission
async function submitForm() {
  const isFormInvalid = await v$.value.$validate()
  if (!isFormInvalid) {
    return
  }

  try {
    isSending.value = true
    const result = await newsletterSubscribe(state.email)
    console.log('result', result)
    emit('submit')
  } catch (error) {
    console.error('error', error)
  } finally {
    isSending.value = false
  }
}
</script>

<template>
  <form id="newsletter" :name="name" novalidate="true" @submit.prevent="submitForm">
    <FormInput
      v-model="state.email"
      type="email"
      placeholder="Your email address"
      label="Your email address"
      name="email"
      :is-required="true"
      :is-label-visible="false"
      :is-error="v$.email.$error"
      :message="v$.$errors.length > 0 && v$.email.$errors[0]?.$message"
      :is-message-visible="v$.email.$error"
      :message-fixed="true"
      @change="v$.email.$touch"
    />
    <div class="flex flex-col gap-12 lg:mt-1 lg:flex-row lg:gap-20">
      <div v-if="disclaimer" class="text-xs lg:text-sm">
        {{ disclaimer }}
      </div>
      <div class="text-center lg:text-right">
        <Button type="submit" size="lg" variant="cta" label="Subscribe" />
      </div>
    </div>
  </form>
</template>
